<div [ngClass]="!isNoteEntry ? 'little-dialog' : 'big-dialog'">
    <div class="modal-header">
        <h4 class="modal-title text-center">Approval</h4>
        <img alt="" class="modal-close" (click)="dismissModal()">
    </div>
    <div class="modal-body">
        <div *ngIf="!isNoteEntry">
            <div class="btn list-button btn-block" (click)="setMechGradeAnswer('GA')"
                [ngClass]="{'selected': buyerMechGrade === 'GA', 'disabled': !isMechGradeEnabled('GA')}">
                <span class="tick-button-icon"></span>Approve with Mech Grade A
            </div>
            <div class="btn list-button btn-block" (click)="setMechGradeAnswer('GB')"
                [ngClass]="{'selected': buyerMechGrade === 'GB', 'disabled': !isMechGradeEnabled('GB')}">
                <span class="tick-button-icon"></span>Approve with Mech Grade B
            </div>
            <div class="btn list-button btn-block" (click)="setMechGradeAnswer('GC')"
                [ngClass]="{'selected': buyerMechGrade === 'GC', 'disabled': !isMechGradeEnabled('GC')}">
                <span class="tick-button-icon"></span>Approve with Mech Grade C
            </div>
        </div>
        <div *ngIf="isNoteEntry" class="row">
            <span class="counter">{{noteText.length}}/1000</span>
            <textarea [(ngModel)]="noteText" class="col-12 row ms-0 me-0 text-area" maxlength="1000"
                placeholder="You can add a comment on why the mech grade has been changed"></textarea>
            <div class="col-1"></div>
            <div class="col-5 ps-0 modal-button-left pad-top">
                <button class="btn btn-block btn-lg modal-button clear-button" (click)="clear()">
                    Clear
                </button>
            </div>
            <div class="col-5 modal-button-right pe-0 pad-top">
                <button class="btn btn-block btn-lg modal-button button_green" (click)="approve()">
                    Approve
                </button>
            </div>
            <div class="col-1"></div>
        </div>
    </div>
</div>